/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Inbox_Na_Detail_DoneInputs */

const en_inbox_na_detail_done = /** @type {(inputs: Inbox_Na_Detail_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.total} steps done`)
};

const id_inbox_na_detail_done = /** @type {(inputs: Inbox_Na_Detail_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} dari ${i?.total} langkah selesai`)
};

/**
* | output |
* | --- |
* | "{done} of {total} steps done" |
*
* @param {Inbox_Na_Detail_DoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_detail_done = /** @type {((inputs: Inbox_Na_Detail_DoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Detail_DoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_detail_done(inputs)
	return en_inbox_na_detail_done(inputs)
});